import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import PageHeadingNew from "../common-components/custom-comps/PageHeadingNew";
import PayroleTabs from "./payrole-dash/PayroleTabs";

const PayroleStructure = ({ userInfoData }) => {
  return (
    <HelmetWrapper title="WTF: Payrole Processor">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <PageHeadingNew
              heading="Advanced Payroll Processor"
              subheading="Multi-gym payroll management with real-time processing and timeline tracking"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <PayroleTabs userInfoData={userInfoData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PayroleStructure;
